<template>
  <!-- ユーザーアイコン、氏名、ランク、ナビゲーションエリア -->
  <div class="p-the-h01-profile-panel" :style="{backgroundColor: lightColorCode}">
    <div class="p-the-h01-profile-panel__left">
      <div v-if="userInfo" class="p-the-h01-profile-panel__icon">
        <!-- ユーザーアイコン -->
        <IconUserImage :size="64" :is-loading="isLoading">
          <img
            v-if="userInfo && userInfo.avatar && userInfo.avatar !== ''"
            class="avatar"
            :src="userInfo.avatar"
            :alt="fullName"
          />
        </IconUserImage>
      </div>
    </div>
    <div class="p-the-h01-profile-panel__right">
      <div class="p-the-h01-profile-panel__profile">
        <!-- 氏名 -->
        <span class="p-the-h01-profile-panel__profile__name" data-translate-skip>{{ fullName }}</span>
        <!-- ランク #59042対応によりセッション情報からrankImagePcを取得するように修正-->
        <IconUserRank
          v-if="!isSp && userInfo && userInfo.rankDisplayEnabled === true"
          :size="120"
        >
          <img v-if="rankImage" :src="rankImage" />
        </IconUserRank>
      </div>
      <!-- ナビゲーション -->
      <nav>
        <ul class="p-the-h01-profile-panel__navi">
          <li>
            <a :href="urls.mypage">
              <span class="p-the-h01-profile-panel__navi__text">マイページ</span>
            </a>
          </li>
          <li v-if="thanksPointEnabled && !isGroupBudget">
            <a :href="urls.thanksPoint">
              <span class="p-the-h01-profile-panel__navi__text">{{ thanksName }}メッセージ</span>
            </a>
          </li>
          <li>
            <a :href="urls.whatsNew">
              <span class="p-the-h01-profile-panel__navi__text">お知らせ</span>
            </a>
          </li>
          <li>
            <a :href="urls.orders">
              <span class="p-the-h01-profile-panel__navi__text">申込履歴</span>
            </a>
          </li>
          <li>
            <a :href="urls.visit">
              <span class="p-the-h01-profile-panel__navi__text">閲覧履歴</span>
            </a>
          </li>
          <li>
            <a :href="urls.favorites">
              <span class="p-the-h01-profile-panel__navi__text">お気に入り</span>
            </a>
          </li>
          <li v-if="!showMailSettings && !isGroupBudget">
            <a :href="urls.mailSettings">
              <span class="p-the-h01-profile-panel__navi__text">メール受信設定</span>
            </a>
          </li>
          <li>
            <a :href="urls.faq">
              <span class="p-the-h01-profile-panel__navi__text">FAQ</span>
            </a>
          </li>
          <li>
            <a :href="urls.qa">
              <span class="p-the-h01-profile-panel__navi__text">お問い合わせ</span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>

  <div class="p-the-h01-point-area">
    <div class="p-the-h01-point-left">
      <!-- 商品交換可能ポイントエリア -->
      <div class="p-the-h01-replaceable-point-panel">
        <div class="p-the-h01-replaceable-point-panel__top">
          <!-- 商品交換可能ポイント -->
          <div class="p-the-h01-replaceable-point-panel__total">
            <div class="p-the-h01-replaceable-point-panel__total__header">
              <span class="p-the-h01-replaceable-point-panel__total__heading">商品交換可能ポイント</span>
              <HelpTooltip
                v-if="thanksPointEnabled"
                :text="replaceablePointText"
              />
            </div>
            <div
              class="p-the-h01-replaceable-point-panel__total__point"
              data-translate-skip
            >
              <span class="p-the-h01-replaceable-point-panel__total__point__text">
                {{ addComma(replaceablePoint) }}
              </span>
              <span class="p-the-h01-replaceable-point-panel__total__point__unit">
                {{ unit.point }}
              </span>
            </div>
          </div>
          <div v-if="localShowButton" class="p-the-h01-replaceable-point-panel__buttons">
            <ButtonMain
              tag="a"
              class="-life"
              :href="urls.life"
              style="background: #089398"
            >
              <span class="p-the-h01-replaceable-point-panel__buttons__label">
                {{ lifeText }}
              </span>
              <IconBase
                :width="24"
                :height="24"
                view-box="0 0 24 24"
              >
                <IconArrowRight />
              </IconBase>
            </ButtonMain>
            <ButtonMain
              tag="a"
              class="-goods"
              :href="urls.goods"
              style="background: #F36D0D"
            >
              <span class="p-the-h01-replaceable-point-panel__buttons__label">
                {{ goodsText }}
              </span>
              <IconBase
                :width="24"
                :height="24"
                view-box="0 0 24 24"
              >
                <IconArrowRight />
              </IconBase>
            </ButtonMain>
          </div>
        </div>
        <div class="p-the-h01-replaceable-point-panel__bottom">
          <!-- 付与ポイント -->
          <div
            v-if="isGroupBudget == false"
            class="p-the-h01-replaceable-point-panel__list__item"
          >
            <span class="p-the-h01-replaceable-point-panel__list__heading"
              >付与ポイント</span
            >
            <div class="p-the-h01-replaceable-point-panel__list__point">
              <span
                v-if="point.grant_points >= 0"
                class="p-the-h01-replaceable-point-panel__list__point__text"  
              >
                {{ addComma(point.grant_points) }}
              </span>
              <span v-else>---</span>
              <span
                class="p-the-h01-replaceable-point-panel__list__point__unit"
                data-translate-skip
              >
                {{ unit.point }}
              </span>
            </div>
          </div>
          <!-- サンクスポイント -->
          <div
            v-if="(thanksPointEnabled || point.thanks_points > 0) && isGroupBudget == false"
            class="p-the-h01-replaceable-point-panel__list__item"
          >
            <span class="p-the-h01-replaceable-point-panel__list__heading"
              >{{ thanksPointName }}</span
            >
            <div class="p-the-h01-replaceable-point-panel__list__point">
              <span
                v-if="point.thanks_points >= 0"
                class="p-the-h01-replaceable-point-panel__list__point__text"  
              >
                {{ addComma(point.thanks_points) }}
              </span>
              <span v-else>---</span>
              <span
                class="p-the-h01-replaceable-point-panel__list__point__unit"
                data-translate-skip
              >
                {{ unit.point }}
              </span>
            </div>
          </div>
          <!-- 健康ポイント -->
          <div
            v-if="ShowKenko && isGroupBudget == false"
            class="p-the-h01-replaceable-point-panel__list__item"
          >
            <span class="p-the-h01-replaceable-point-panel__list__heading"
              >健康ポイント（自動付与）</span
            >
            <div class="p-the-h01-replaceable-point-panel__list__point">
              <span
                v-if="point.kenko_points >= 0"
                class="p-the-h01-replaceable-point-panel__list__point__text"  
              >
                {{ addComma(point.kenko_points) }}
              </span>
              <span v-else>---</span>
              <span
                class="p-the-h01-replaceable-point-panel__list__point__unit"
                data-translate-skip
              >
                {{ unit.point }}
              </span>
            </div>
          </div>
          <!-- GroupBudgetポイント -->
          <div
            v-if="isGroupBudget"
            class="p-the-h01-replaceable-point-panel__list__item"
          >
            <span class="p-the-h01-replaceable-point-panel__list__heading"
              >{{ userInfo.groupBudgetName }}</span
            >
            <div class="p-the-h01-replaceable-point-panel__list__point">
              <span
                v-if="point.group_budget_point >= 0"
                class="p-the-h01-replaceable-point-panel__list__point__text"  
              >
                {{ addComma(point.group_budget_point) }}
              </span>
              <span v-else>---</span>
              <span
                class="p-the-h01-replaceable-point-panel__list__point__unit"
                data-translate-skip
              >
                {{ unit.point }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- サンクス専用ポイントエリア -->
      <div
        v-if="thanksPointEnabled && thanksExclusiveEnabled && isGroupBudget == false"
        class="p-the-h01-thanks-only-point-panel"
      >
        <span class="p-the-h01-thanks-only-point-panel__heading">
          {{ thanksOnlyPointName }}<span
            class="p-the-h01-thanks-only-point-panel__tooltip"
          ><HelpTooltip :text="thanksOnlyPointText" /></span>
        </span>
        <div
          class="p-the-h01-thanks-only-point-panel__point"
          data-translate-skip
        >
          <span class="p-the-h01-thanks-only-point-panel__point__text">
            {{ addComma(point.thanks_exclusive_points) }}
          </span>
          <span class="p-the-h01-thanks-only-point-panel__point__unit">
            {{ unit.point }}
          </span>
        </div>
      </div>

      <!-- 有効期限エリア -->
      <div class="p-the-h01-expiration-panel">
        <a :href="urls.expiring" class="p-the-h01-expiration-panel__link">
          <span class="p-the-h01-expiration-panel__link__text">ポイント有効期限一覧</span>
        </a>
        <a :href="urls.expired" class="p-the-h01-expiration-panel__link">
          <span class="p-the-h01-expiration-panel__link__text">有効期限切れのポイント一覧</span>
        </a>
      </div>

      <!-- ポイント実績エリア -->
      <TheH01PointAchievementPanel />
    </div>
    <div class="p-the-h01-point-right">
      <!-- 付与基準例エリア -->
      <TheH01GrantCriteriaPanel />
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import IconUserImage from "@/common/components/icons/IconUserImage.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";

import { addComma as addCommaFilter } from "@/common/assets/js/filters";
import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";
import CONST_DATA from "@/general/mixins/const/constData";

import { getUserProfile } from "@/general/store/api";
import { UserInfo } from "@/general/store/models";
import auth from "@/general/store/modules/auth";
import LocalStorage from "@/general/utils/storage";
import AuthApi from "@/general/api/authApi";
import IconUserRank from "@/common/components/icons/IconUserRank.vue";
import IconArrowRight from "@/common/components/icons/IconArrowRight.vue";
import HelpTooltip from "@/common/components/molecules/HelpTooltip.vue";
import TheH01PointAchievementPanel from "@/general/components/pages/parts/PointHistoryList/TheH01PointAchievementPanel.vue";
import TheH01GrantCriteriaPanel from "@/general/components/pages/parts/PointHistoryList/TheH01GrantCriteriaPanel.vue";
import {
  getThanksPointName,
  getThanksOnlyPointName
} from "@/common/assets/js/utils/pointName";

@Options({
  name: "TheH01ProfilePanel",
  props: {
    lightColorCode: { type: String },
    showButton: { type: Boolean, required: false, default: false }
  },
  components: {
    IconUserImage,
    IconBase,
    IconUserRank,
    IconArrowRight,
    HelpTooltip,
    TheH01PointAchievementPanel,
    TheH01GrantCriteriaPanel
  }
})
export default class TheH01ProfilePanel extends Vue {
  showButton!: boolean;
  localShowButton = false;

  point: any = {};
  userInfo: UserInfo = {} as UserInfo;
  isLoading = true;
  lightColorCode: string;

  get fullName() {
    return commons.getNameFromUser(commons.userInfo);
  }

  get unit() {
    return commons?.unit;
  }

  get replaceablePoint() {
    if (this.isGroupBudget) {
      return this.point.group_budget_point;
    }
    return this.point.total_points;
  }

  get isSp() {
    return globals?.isLargeBreakpointWidthOfSp;
  }

  get isSpScreenWidth() {
    return globals?.isSpScreenWidth;
  }

  get rankImage() {
    return this.userInfo?.rankImagePc;
  }

  get urls() {
    return {
      mypage: process.env.VUE_APP_MYPAGE,
      thanksPoint: CONST_DATA.SITE_MAP.THANKS_POINT,
      whatsNew: CONST_DATA.SITE_MAP.WHATS_NEW,
      orders: process.env.VUE_APP_MYPAGE + "/orders",
      visit: process.env.VUE_APP_MYPAGE + "/visits/",
      favorites: process.env.VUE_APP_MYPAGE + "/favorites/",
      mailSettings: CONST_DATA.SITE_MAP.MAIL_DELIVERY_SETTINGS,
      faq: process.env.VUE_APP_BS_DOMAIN + "/contents/cgi/incentive/faq3/",
      qa: process.env.VUE_APP_BS_DOMAIN + "/contents/cgi/memberfaqic/index.html",
      life: process.env.VUE_APP_IC_DOMAIN + CONST_DATA.SITE_MAP.PRODUCT + "?selected=life",
      goods: process.env.VUE_APP_IC_DOMAIN + CONST_DATA.SITE_MAP.PRODUCT + "?selected=goods",
      expired: CONST_DATA.SITE_MAP.EXPIRED_POINTS,
      expiring: CONST_DATA.SITE_MAP.EXPIRING_POINTS
    };
  }

  get ShowKenko() {
    return auth.user.kenko;
  }

  get showMailSettings() {
    return (
      !auth.user.approval_result_notification_mail &&
      !auth.user.point_expiry_notification_enabled &&
      !auth.user.point_balance_notification_enabled &&
      !auth.user.point_receipt_notification_enabled &&
      !auth.user.mail_magazine_enabled
    );
  }

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode;
  }

  get thanksPointEnabled() {
    return auth.user?.thanks_point_enabled;
  }

  get allowPointsRegifting() {
    return auth.user?.allow_points_regifting;
  }

  get thanksExclusiveEnabled() {
    // const orgAdminSettings = LocalStorage.getItem("orgAdminSettings")
    //   ? JSON.parse(LocalStorage.getItem("orgAdminSettings") as string)
    //   : [];
    // if (
    //   orgAdminSettings &&
    //   orgAdminSettings.length > 0 &&
    //   orgAdminSettings[0] &&
    //   orgAdminSettings[0].thanks_exclusive_points_enabled
    // ) {
    //   return true;
    // }

    // return false;

    const userDetails = LocalStorage.getItem("userDetails");
    if (userDetails) {
      const userDetailsJson = JSON.parse(userDetails);
      return userDetailsJson.thanks_exclusive_points_enabled;
    }
    return false;
  }

  get thanksPointName() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME1);
  }

  get thanksName() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME2);
  }

  get thanksOnlyPointName() {
    return getThanksOnlyPointName(
      CONST_DATA.POINT_NAME.THANKS_ONLY_POINT_DEFAULT_NAME1
    );
  }

  get lifeText() {
    return this.isSpScreenWidth ? "Life Service商品" : "Life Service商品を探す";
  }

  get goodsText() {
    return this.isSpScreenWidth ? "Goods商品" : "Goods商品を探す";
  }

  get replaceablePointText() {
    if (
      this.thanksPointEnabled &&
      this.thanksExclusiveEnabled &&
      !this.allowPointsRegifting
    ) {
      return CONST_DATA.TOOLTIP_TEXT.REPLACEABLE_POINT_EXCHANGE_ONLY;
    }
    return CONST_DATA.TOOLTIP_TEXT.REPLACEABLE_POINT;
  }

  get thanksOnlyPointText() {
    if (this.allowPointsRegifting) {
      return CONST_DATA.TOOLTIP_TEXT.THANKS_ONLY_POINT_SUPPLEMENT;
    }
    return CONST_DATA.TOOLTIP_TEXT.THANKS_ONLY_POINT;
  }

  async created() {
    this.localShowButton = this.showButton;
    this.evaluateShowButton();

    await commons.setOrgPageSpecificDataFromLocalStorage();

    await AuthApi.getICSession()
      .then((result) => {
        const ic_session = JSON.parse(result);
        this.userInfo = ic_session;
        this.isLoading = false;
      })
      .catch(() => {
        this.userInfo = auth.user;
        this.isLoading = false;
      });

    this.point = await getUserProfile("");
  }

  addComma = addCommaFilter;

  evaluateShowButton() {
    if (auth.user.displayExchangeButton === false) {
      this.localShowButton = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.p-the-h01-profile-panel {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  gap: 16px;
  border-radius: 8px;

  &__left {
    .avatar {
      @include object-fit("contain");
      width: 100%;
      height: 100%;
    }
  }

  &__icon {
    display: block;
    position: relative;
    border-radius: 50%;
    border: px(1) solid $common-gray300;
  }

  &__right {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    gap: 4px;
  }

  &__profile {
    display: flex;
    align-items: center;

    &__name {
      font-family: 'Noto Sans JP';
      font-weight: bold;
      font-size: 20px;
      line-height: 125%;
      font-feature-settings: 'pwid' on, 'palt' on;
      color: $common-black;
      overflow-wrap: anywhere;

      @include sp {
        font-size: 16px;
      }
    }
  }

  &__navi {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px;
    gap: 8px;
    flex-wrap: wrap;

    &__text {
      font-family: 'Noto Sans JP';
      font-style: normal;
      font-weight: 700;
      font-size: 12px;
      line-height: 180%;
      text-decoration-line: underline;
      font-feature-settings: 'palt' on, 'pwid' on;
      color: $common-black;
      overflow-wrap: anywhere;
    }
  }
}
.p-the-h01-point-area {
  display: flex;
  align-items: flex-start;
  margin-top: rem(20);
  width: 100%;

  @include large-pc {
    flex-direction: row;
    gap: rem(16);
  }

  @include large-sp {
    flex-direction: column;
    gap: rem(20);
  }
}

.p-the-h01-expiration-panel {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  padding: 0px;
  gap: 8px;
  width: 100%;

  @include pc {
    justify-content: flex-end;
  }

  @include large-sp {
    justify-content: center;
  }

  &__link {
    &__text {
      font-family: 'Noto Sans JP';
      font-style: normal;
      font-weight: 700;
      line-height: 180%;
      text-decoration-line: underline;
      font-feature-settings: 'palt' on, 'pwid' on;
      color: #0D76BF;
      white-space: nowrap;

      @include pc {
        font-size: 12px;
      }

      @include sp {
        font-size: 10px;
      }
    }
  }
}

.p-the-h01-point-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;
  min-width: 0;
  left: 0px;
  top: 0px;

  @include large-pc {
    flex: 7 1 0;
  }

  @include large-sp {
    width: 100%;
  }
}

.p-the-h01-point-right {
  min-width: 0;

  @include large-pc {
    flex: 3 1 0;
  }

  @include large-sp {
    width: 100%;
  }

  &:not(:has(.p-the-h01-grant-criteria-panel)) {
    display: none;
  }
}

.p-the-h01-replaceable-point-panel {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px;
  gap: 24px;
  width: 100%;
  background: #FFFFFF;
  border: 2px solid #F4F5F6;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;

  &__top {
    display: flex;
    align-items: center;
    padding: 0px;
    width: 100%;

    @include pc {
      flex-direction: row;
      gap: 10px;
    }

    @include sp {
      flex-direction: column;
      gap: 16px;
    }
  }

  &__total {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    gap: 8px;
    flex-grow: 1;
    flex: 1 0 auto;

    @include pc {
      min-height: 67px;
    }

    @include sp {
      min-height: 52px;
    }

    &__header {
      align-items: center;
      padding: 0px;

      @include pc {
        min-height: 23px;
      }

      @include sp {
        min-height: 20px;
      }
    }

    &__heading {
      font-family: 'Noto Sans JP';
      font-style: normal;
      font-weight: 700;
      line-height: 125%;
      font-feature-settings: 'pwid' on, 'palt' on;
      color: $common-black;
      overflow-wrap: anywhere;

      @include pc {
        font-size: 18px;
      }

      @include sp {
        font-size: 16px;
      }
    }

    &__point {
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      padding: 0px;

      @include pc {
        height: 36px;
      }

      @include sp {
        height: 24px;
      }

      &__text {
        font-family: 'Noto Sans JP';
        font-style: normal;
        font-weight: 700;
        line-height: 100%;
        display: flex;
        align-items: center;
        font-feature-settings: 'palt' on, 'pwid' on;
        color: $common-black;

        @include pc {
          height: 36px;
          font-size: 36px;
        }

        @include sp {
          height: 24px;
          font-size: 24px;
        }
      }

      &__unit {
        font-family: 'Noto Sans JP';
        font-style: normal;
        font-weight: 700;
        line-height: 100%;
        display: flex;
        align-items: center;
        font-feature-settings: 'palt' on, 'pwid' on;
        color: $common-black;

        @include pc {
          height: 14px;
          font-size: 14px;
        }

        @include sp {
          height: 12px;
          font-size: 12px;
        }
      }
    }
  }

  &__buttons {
    display: flex;
    justify-content: center;
    padding: 0px;

    @include pc {
      min-width: 0;
      max-width: 235px;
      flex-direction: column;
      gap: 8px;
    }

    @include sp {
      width: 100%;
      flex-direction: row;
      gap: 16px;

    }
    :deep(.p-button-main) {
      display: flex;
      align-items: center;
      overflow-wrap: anywhere;

      svg {
        flex-shrink: 0;
      }

      @include pc {
        min-height: 36px;
      }

      @include sp {
        justify-content: center;
        min-height: 34px;
        padding-left: 0;
        padding-right: 0;
      }
    }

    :deep(.p-button-main.-life) {
      @include sp {
        min-width: 150px;
      }
    }

    :deep(.p-button-main.-goods) {
      @include sp {
        min-width: 110px;
      }
    }

    &__label {
      display: block;
      align-items: center;
      flex: 1 1 auto;
      min-width: 0;
      padding-left: 10px;
      @include pc {
        flex: 1 0 0;
        text-align: left;
      }
    }
  }

  &__bottom {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    width: 100%;
  }

  &__list {
    &__item {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 0px;
      gap: 8px;
      width: 100%;
      padding: .625rem 0;

      &:not(:last-child) {
        border-bottom: 1px solid $common-gray300;
      }
    }

    &__heading {
      margin: 0 auto;
      font-family: 'Noto Sans JP';
      font-style: normal;
      font-weight: 400;
      line-height: 125%;
      font-feature-settings: 'pwid' on, 'palt' on;
      flex-grow: 1;
      color: $common-black;
      overflow-wrap: anywhere;

      @include pc {
        font-size: 16px;
      }

      @include sp {
        font-size: 14px;
      }
    }
    
    &__point {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: flex-end;
      padding: 0px;
      margin: 0 auto;
      white-space: nowrap;

      &__text {
        font-family: 'Noto Sans JP';
        font-style: normal;
        font-weight: 700;
        line-height: 100%;
        display: flex;
        align-items: center;
        font-feature-settings: 'palt' on, 'pwid' on;
        color: $common-black;

        @include pc {
          font-size: 16px;
        }

        @include sp {
          font-size: 14px;
        }
      }

      &__unit {
        font-family: 'Noto Sans JP';
        font-style: normal;
        font-weight: 700;
        line-height: 100%;
        display: flex;
        align-items: center;
        font-feature-settings: 'palt' on, 'pwid' on;
        color: $common-black;

        @include pc {
          font-size: 12px;
        }

        @include sp {
          font-size: 10px;
        }
      }
    }
  }
}

.p-the-h01-thanks-only-point-panel {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: rem(16);
  gap: rem(8);
  width: 100%;
  min-width: 0;
  background: $common-white;
  border: px(2) solid #f4f5f6;
  box-shadow: 0 0 px(4) rgba(0, 0, 0, 0.1);
  border-radius: rem(8);

  &__heading {
    display: inline;
    font-family: "Noto Sans JP";
    font-size: rem(16);
    font-weight: 700;
    line-height: 125%;
    font-feature-settings: "pwid" on, "palt" on;
    color: $common-black;
    overflow-wrap: anywhere;
    flex: 1 1 auto;
    min-width: 0;
  }

  &__tooltip {
    display: inline-flex;
    align-items: center;
    margin-left: rem(4);
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }

  &__point {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-end;
    flex-shrink: 0;
    white-space: nowrap;
    color: $common-black;

    &__text {
      font-family: "Noto Sans JP";
      font-size: rem(24);
      font-weight: 700;
      line-height: 100%;
      font-feature-settings: "palt" on, "pwid" on;
    }

    &__unit {
      font-family: "Noto Sans JP";
      font-size: rem(12);
      font-weight: 700;
      line-height: 100%;
      font-feature-settings: "palt" on, "pwid" on;
    }
  }

  @include sp {
    &__heading {
      font-size: rem(14);
    }

    &__point {
      &__text {
        font-size: rem(18);
      }

      &__unit {
        font-size: rem(12);
      }
    }
  }
}
</style>
